import React from "react";
import { css } from "@emotion/core";

export const PURPLE = '#792583';
export const DARK_ROW = '#374151';
export const DARK_ROW_LIGHT = '#4B5563';
export const GREEN_BG = '#DCFCE7';
export const GREEN_TXT = '#007D2E';
export const ORANGE_BG = '#FFEBD5';
export const ORANGE_TXT = '#D97706';
export const RED_BG = '#FFE2E2';
export const RED_TXT = '#DC2626';
export const BORDER_GREY = '#AAAAAA';
export const TEXT_GREY = '#374151';

// Month columns shown across all Service Portal performance reports.
// Add a new month here (e.g. { key: 'may', label: 'May 2026' }) and every
// report picks it up automatically. `key` must match the data field suffix,
// e.g. key 'april' => row fields perf_april / att_april / cost_april / etc.
export const MONTHS = [
    { key: 'mtd', label: 'MTD' },
    { key: 'april', label: 'April 2026' },
    { key: 'march', label: 'March 2026' },
];

export const HEADER_TH = { textAlign: 'center', padding: '12px 10px', color: '#FFFFFF', fontWeight: 'bold', backgroundColor: PURPLE, border: '1px solid rgba(255,255,255,0.15)', verticalAlign: 'middle' };
export const SUB_HEADER_TH = { textAlign: 'center', padding: '10px 10px', color: PURPLE, fontWeight: 'bold', backgroundColor: '#FFFFFF', border: `1px solid ${BORDER_GREY}`, verticalAlign: 'middle' };
export const DATA_TD = { textAlign: 'center', padding: '12px 14px', fontWeight: 'bold', border: '1px solid #FFFFFF', verticalAlign: 'middle' };
export const TEXT_TD = { padding: '12px 14px', color: TEXT_GREY, border: `1px solid ${BORDER_GREY}`, verticalAlign: 'middle' };
export const GROUP_TD = { padding: '12px 14px', color: '#FFFFFF', fontWeight: 'bold', border: '1px solid rgba(255,255,255,0.15)', verticalAlign: 'middle' };

export const spinnerOverride = css`
    display: block;
    margin: 0 auto;
    border-color: red;
    text-align: center;
`;

export const CheckIcon = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginLeft: '8px', verticalAlign: 'middle' }}>
        <path d="M7.99998 14.6663C11.6819 14.6663 14.6666 11.6816 14.6666 7.99967C14.6666 4.31778 11.6819 1.33301 7.99998 1.33301C4.31808 1.33301 1.33331 4.31778 1.33331 7.99967C1.33331 11.6816 4.31808 14.6663 7.99998 14.6663Z" stroke="#16A34A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M6 8.00033L7.33333 9.33366L10 6.66699" stroke="#16A34A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);

export const CrossIcon = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginLeft: '8px', verticalAlign: 'middle' }}>
        <path d="M7.89469 14.4163C11.5766 14.4163 14.5614 11.4316 14.5614 7.74967C14.5614 4.06778 11.5766 1.08301 7.89469 1.08301C4.2128 1.08301 1.22803 4.06778 1.22803 7.74967C1.22803 11.4316 4.2128 14.4163 7.89469 14.4163Z" stroke="#DC2626" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M9.89453 5.75L5.89453 9.75" stroke="#DC2626" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M5.89453 5.75L9.89453 9.75" stroke="#DC2626" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);
